import { injectIntl } from 'react-intl';
import Summary from './Summary';
import config from './config';

export const CONFIG = config;

export default injectIntl(Summary);
